<template>
    <CourseListPublicComponent />
</template>


<script>
import CourseListPublicComponent from '../../components/courses/course_list_public.vue'

export default {
    data() {
        return {

        }
    },
    methods : {
    },
    components: {
        CourseListPublicComponent
    }
}
</script>